export default "<div id=\"toast-message\" [class]=\"className\" [class.show]=\"show\">{{message}}</div>"